module.exports = __webpack_public_path__ + "static/media/rudolf_mobile.89de3d87.webm";